var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { LoadingIcon } from '@cvent/carina-progress-indicator';
import { AlertCircleIcon } from '@cvent/carina-icon';
import iconTypes from './StepIconTypes';
import useStyle from './SubStepStyles';
var SubStep = function (_a) {
    var isCurrentSubStep = _a.isCurrentSubStep, onClick = _a.onClick, subStep = _a.subStep, isRtl = _a.isRtl;
    var _b = __read(useState(false), 2), hover = _b[0], setHover = _b[1];
    var _c = useStyle({
        isRtl: isRtl,
        isCurrentSubStep: isCurrentSubStep,
        status: subStep === null || subStep === void 0 ? void 0 : subStep.status,
        hover: hover
    }), wrapper = _c.wrapper, main = _c.main, name = _c.name, iconWrapper = _c.iconWrapper, spacer = _c.spacer;
    return (_jsxs("div", __assign({ css: wrapper, onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } }, { children: [_jsx("div", { css: spacer }, void 0),
            _jsxs("button", __assign({ type: "button", css: main, onClick: onClick }, { children: [_jsx("div", __assign({ css: name }, { children: subStep.name }), void 0),
                    _jsxs("div", __assign({ css: iconWrapper }, { children: [subStep.status === iconTypes.error && (_jsx(AlertCircleIcon, { color: iconWrapper.color, size: "m" }, void 0)),
                            subStep.status === iconTypes.processing && _jsx(LoadingIcon, { size: "m" }, void 0)] }), void 0)] }), void 0)] }), void 0));
};
export default SubStep;
